import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";
import { useSelector } from "react-redux";
import { Layout } from "antd";
import LayoutHeader from "./layoutHeader";
import ProtectedRoute from "./ProtectedRoute";
import SideBaruser from "./sideBar";
import Receptionist from "../receptionist/receptionist";
import ReceptionistProfile from "../receptionist/profile/receptionistProfile";
import VisitorsDetails from "../receptionist/visitorsDetails/visitorsDetails";
import TelecallerIndex from "../receptionist/telecallerDetails/telecallerIndex";
import UpdateVisitors from "../receptionist/visitorsDetails/updateVisitors";
import ProjectIndex from "../receptionist/projectDetails/projectIndexx";
import TaskDetatils from "../receptionist/projectDetails/taskDetatils";
import ClientIndex from "../receptionist/client";
import LeaveDetails from "../receptionist/leaveDetails/leaveDetails";
import Salary_Details from "../receptionist/profile/salary_Details";

const ReceptionistNavigation = () => {
  const user = useSelector((state: any) => state.user);
  const [collapsed, setCollapsed] = useState(false);
  const { Sider, Content } = Layout;

  return (
    <Layout>
      <Sider
        style={{ backgroundColor: "#FF1A1A", height: "100vh" }}
        trigger={null}
        collapsible
        collapsed={collapsed}
        width={collapsed ? 40 : 250}
      >
        <SideBaruser
          collapsed={collapsed}
          doCollapse={() => setCollapsed(!collapsed)}
        />
      </Sider>
      <Layout>
        <LayoutHeader />
        <Content style={{ background: "#fff" }}>
          <Routes>
            <Route path="/" element={<Receptionist />} />

            <Route
              path="/Receptionist_Dashboard"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Receptionist />
                </ProtectedRoute>
              }
            />

            <Route
              path="/Receptionist_profile"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ReceptionistProfile />
                </ProtectedRoute>
              }
            />

            <Route
              path="/Visitors"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <VisitorsDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Telecaller_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TelecallerIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Visitors_details/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <UpdateVisitors />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ProjectIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Project_Details/view_task_Details/:id"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <TaskDetatils />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Client_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <ClientIndex />
                </ProtectedRoute>
              }
            />
            <Route
              path="/Leave_Details"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <LeaveDetails />
                </ProtectedRoute>
              }
            />
            <Route
              path="/viewSalaryDetails"
              element={
                <ProtectedRoute isSignedIn={user.isAuthenticated}>
                  <Salary_Details />
                </ProtectedRoute>
              }
            />
          </Routes>
        </Content>
      </Layout>
    </Layout>
  );
};

export default ReceptionistNavigation;
